import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { LockPersonOutlined, Payment } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { ResetPassword } from "../../components/my-profile";
import { UserActivities, UserDetails } from "../../components/administration";
import { PageHeader } from "../../components/v3";
import { ADD_USER_PAYMENT, RESET_USER_PASSWORD, VIEW_USER_STATEMENT } from "../../constants";
import { useHasPermission } from "../../utils";

export const SingleUser = () => {
  const [name, setName] = useState("");
  const [userAccountId, setUserAccountId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hasAddPayment = useHasPermission(ADD_USER_PAYMENT);
  const hasUserPasswordReset = useHasPermission(RESET_USER_PASSWORD);
  const hasUserStatementView = useHasPermission(VIEW_USER_STATEMENT);

  const { id } = useParams();
  const navigate = useNavigate();

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasAddPayment && {
      buttonText: "Add Payment",
      buttonIcon: Payment,
      onClick: () => navigate(`/transaction/add?userId=${id}`),
    },
    hasUserPasswordReset && {
      buttonText: "Reset Password",
      buttonIcon: LockPersonOutlined,
      onClick: handleOpenModal,
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title="User Information"
            // button
            buttons={buttons}
          />
        </Box>

        {/* details */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <UserDetails
            onSuccess={({ accountId, firstName, lastName }) => {
              setUserAccountId(accountId);
              setName(`${firstName} ${lastName}`);
            }}
            reloadData={reload}
          />
        </Box>

        {hasUserStatementView && (
          <UserActivities name={name} userId={id} accountId={userAccountId} onSuccess={handleReload} reloadData={reload} />
        )}
      </PageLayout>

      <ResetPassword userId={id} open={openModal} onClose={handleCloseModal} />
    </>
  );
};
